import React from 'react';
import classNames from 'classnames';
import { CustomerInfoForList } from '../../../external/CustomerListApi';

import CustomerListItem from '../CustomerListItem';

export interface CustomerListTableProps {
  hit: number;
  customerResult: CustomerInfoForList[];
  updateGlobalStateByLocalState: () => void;
}

const componentName = 'CustomerListTable';

const CustomerListTable: React.FC<CustomerListTableProps> = ({ hit, customerResult, updateGlobalStateByLocalState }) => {
  const rowDataOnDisplay = customerResult;

  return (
    <div className={classNames('customer-list-card-list')}>
      <ul>
        {hit === 0 ? (
          <li
            className={classNames('customer-list-card', 'is-no-result')}
            data-testid={`${componentName}-no-result`}
            data-testid-e2e={`${componentName}-no-result`}>
            お客さま情報が見つかりません。
          </li>
        ) : (
          rowDataOnDisplay.map((customerInfo) => (
            <CustomerListItem
              key={customerInfo.customerId}
              customerInfo={customerInfo}
              updateGlobalStateByLocalState={updateGlobalStateByLocalState}
            />
          ))
        )}
      </ul>
    </div>
  );
};

export default CustomerListTable;
